import './css/zyc.scss'
/**
 * 容器
 */
import titleContainer from './container/titleContainer.vue'
import navClassContainer from './container/navClassContainer.vue'
import contentContainer from './container/contentContainer.vue'
import noteContainer from './container/noteContainer.vue'
import headerContainer from './container/headerContainer.vue'
import cardContainer from './container/cardContainer.vue'
import screenContainer from './container/screenContainer.vue'

/**
 * 标签页
 */
import tabs from './tabs/tabs.vue'
import newtabs from './tabs/newtabs.vue'
import tabPane from './tabs/tabPane.vue'

/**
 * 排行Table
 */
import chartsTable from './table/chartsTable.vue'
import chartsTableColumn from './table/chartsTableColumn.vue'
import pageTable from './table/pageTable.vue'
import pageInfoTable from './table/pageInfoTable.vue'
import pageListTable from './table/pageListTable.vue'

/**
 * Button
 */
import buttonGroup from './button/buttonGroup.vue'

/**
 * Checkbox
 */
import checkboxGroup from './checkbox/checkboxGroup.vue'

/**
 * Charts
 */
import chartModule from './echarts/chartModule.vue'

/**
 * 其它
 */
import rotationSwitch from './other/rotationSwitch.vue'
import quarter from './other/quarter.vue'
import screen from './other/screen.vue'
import tags from './other/tags.vue'
import progress from './other/progress.vue'
import tooltipText from './other/tooltipText.vue'
import classTableScreen from './other/classTableScreen.vue'

const components = [
  titleContainer,
  navClassContainer,
  contentContainer,
  noteContainer,
  headerContainer,
  chartsTable,
  chartsTableColumn,
  rotationSwitch,
  cardContainer,
  screen,
  quarter,
  screenContainer,
  pageTable,
  tags,
  buttonGroup,
  checkboxGroup,
  chartModule,
  progress,
  tooltipText,
  tabs,
  tabPane,
  newtabs,
  classTableScreen,
  pageInfoTable,
  pageListTable
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/common/zyc/index.js